<template>
  <div class="contentdetail">
    <button v-on:click="backHistory" class="btn">返回</button>
    <div class="title text-center">{{ article.title }}</div>
    <div class="author text-center margin-top-10 margin-bottom-20">
      作者:
      <span class="margin-left-small margin-right-10">{{ article.author }}</span>
      <i class="iconfont icon-yanjing1"></i>
      <span class="margin-left-small margin-right-20">阅读人数：{{ article.readNum }}</span>
      <span>发布时间：{{ article.publishTime }}</span>
    </div>
    <div class="text-center"></div>
    <div class="desc" v-html="article.content"></div>
    <ul>
      <li v-for="(item, index) in list" :key="index">{{ item.id }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'DetailList',
  props: {
    list: Array,
    article: Object,
  },
  components: {},
  mounted() {},
  methods: {
    backHistory() {
      this.$router.go(-1); // 返回上一层
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
.title{
  font-size:24px;
}
.author{
  font-size:13px;
  color:#999;
}
.desc{
  line-height:30px;
  color:$fontGray;
  text-indent: 2em;
  overflow:hidden;
}
.desc >>> img{
  max-width:100% !important;
  height:auto !important;
  display:block;
  margin:0 auto;
}
.btn{
  width:80px;
  height:30px;
  margin-bottom: 30px;
  line-height:30px;
  border-radius:15px;
  text-align:center;
  background:$bgColor;
  border:1px solid $bgColor;
  color:#fff;
  padding:0;
}
.contentdetail{
  margin-bottom:20px;
  width:100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/detail/components/DetailList.vue